// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { i18n } from '@/plugins'
export const defaultHeader = [
  {
    text: '',
    align: 'start',
    sortable: false,
    width: 5,
    class: 'primary'
  },
  {
    text: i18n.t('common.code'),
    sortable: false,
    value: 'code',
    width: 100,
    class: 'primary'
  },
  {
    text: i18n.t('common.name'),
    sortable: false,
    value: 'name',
    class: 'primary'
  },
  {
    text: '',
    align: 'right',
    sortable: false,
    value: 'action',
    width: 200,
    class: 'primary'
  }
]
